module.exports = {"TITLE":"Tab offers","DESCRIPTION":"These are the Tab offers you have run on Tuango. Click on the images to obtain more information about the performance and results of each offer.","TOTAL_STATS":"Total sales","TAB_DEALS":"Tab offers","CLAIMS_STATS":"Cards linked","TRX_STATS":"Transactions<br><small>#conversionRate#% of claimants</small>","SALES_STATS":"Total sales","STATUS_ACTIVE":"Active","STATUS_ENDED":"Ended"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/deals.json
// module id = 347
// module chunks = 8